var v6 = require('ipv6').v6;
var vsprintf = require('sprintf-js').vsprintf;

var privateRanges = [
    new v6.Address('::ffff:10.0.0.0/104'),
    new v6.Address('::ffff:172.16.0.0/108'),
    new v6.Address('::ffff:192.168.0.0/112')
];

function checkPrivate(ip) {
    for (var key in privateRanges) {
        if (privateRanges.hasOwnProperty(key)) {
            var range = privateRanges[key];

            if (ip.isInSubnet(range)) {
                return true;
            }
        }
    }

    return false;
}

/**
 * Formats a hostname. (removes a trailing . if one is set)
 */
function formatHostname(name) {
    if (name.slice(-1) == '.') {
        return name.slice(0, -1);
    }

    return name;
}

/**
 * Filters an array of IP addresses and returns only public IP addresses.
 */
function filterPublic(ips) {
    return ips.filter(function (ip) {
        ip = new v6.Address(ip);

        return !ip.v4 || !checkPrivate(ip);
    });
}

/**
 * Formats an IP address returned by Invocation. Pass an object containing start, end and
 * bits keys
 */
function formatIpAddress(ipString, skipIfInvalid = false) {
    var ip = new v6.Address(ipString);

    if (!ip.isValid()) {
        return ipString;
    }

    var output = ip.v4 ?
            ip.v4inv6().substr(7) :
            ip.correctForm();

    var subnet = ip.subnet.substr(1);
    if (subnet < 128) {
        if (ip.v4) {
            output += "/" + (parseInt(subnet) - 96);
        } else {
            output += ip.subnet;
        }
    }

    return output;
}

/**
 * Checks if an IP address is private.
 */
function isPrivate(ip) {
    ip = new v6.Address(ip);

    return checkPrivate(ip);
}

/**
 * Checks if the IP is a range.
 */
function isRange(ip) {
    ip = new v6.Address(ip);

    return ip.subnet.substr(1) < 128;
}

/**
 * Aggregates all IP addresses belonging to a service.
 */
function getServiceIps(service) {
    var transit = service.transit;

    var ips = transit.ip_ranges ?
        transit.ip_ranges.slice(0) : [];
    if (transit.wan_ip) {
        ips.push(transit.wan_ip)
    }
    if (transit.ipv6_prefix) {
        ips.push(transit.ipv6_prefix);
    }

    return ips;
}

function getUsageIps(service) {
    var transit = service.transit;

    if (transit.usage_ips && transit.usage_ips.length) {
        return transit.usage_ips;
    }

    return getServiceIps(service);
}

module.exports = {
    formatHostname,
    filterPublic,
    format: formatIpAddress,
    isPrivate,
    isRange,
    serviceIps: getServiceIps,
    usageIps: getUsageIps
};



// WEBPACK FOOTER //
// ./app/util/Ip.js